import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import {
  LikeTwoTone,
} from '@ant-design/icons';

export type CheckButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const ValidateButtonAction = ({
  children = 'Validate',
  onlyIcon = false,
  ...otherProps
}: CheckButtonProps) => {
  return (
    <Button icon={<LikeTwoTone twoToneColor="Green" />} style={{ height: 40 }} {...otherProps}>
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default ValidateButtonAction;

